import { render } from "./GalleryPagePart1ArtGallery.vue?vue&type=template&id=42c7ec8f&scoped=true"
import script from "./GalleryPagePart1ArtGallery.vue?vue&type=script&lang=js"
export * from "./GalleryPagePart1ArtGallery.vue?vue&type=script&lang=js"

import "./GalleryPagePart1ArtGallery.vue?vue&type=style&index=0&id=42c7ec8f&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42c7ec8f"]])

export default __exports__